module.exports = __webpack_public_path__ + "static/media/Rectangle 111.071a7d31.png";